<script setup lang="ts">
import { Xmark } from "@iconoir/vue";
import type { RouteLocationRaw } from "vue-router";

defineProps<{
  redirectOnCloseTarget?: RouteLocationRaw;
}>();
</script>

<template>
  <header class="header">
    <div>
      <h1 class="font-xl"><slot /></h1>
      <p class="subtitle"><slot name="subheading" /></p>
    </div>
    <RouterLink
      v-if="redirectOnCloseTarget"
      :to="redirectOnCloseTarget"
      role="button"
      class="back button button--tertiary"
    >
      <Xmark /><span class="visually-hidden">Zurück</span>
    </RouterLink>
  </header>
</template>

<style scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding-inline: var(--spacing-md);
  padding-block: var(--spacing-ml);
}
</style>
